import {
  GET_DEAL_TASK_LIST_DATA, DELETE_DEAL_TASK_LIST, DELETE_DEAL_TASK_GROUP, SAVE_DEAL_TASK, SAVE_DEAL_TASK_STATUS,
  SAVE_DEAL_TASK_REVIEW_STATUS, DELETE_DEAL_TASK_COMMENT, SAVE_DEAL_TASK_COMMENT, SAVE_DEAL_TASK_LIST,
  SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS, SAVE_DEAL_TASK_TEMPLATE_DATA, LOAD_DEAL_TASK_TEMPLATE_DATA,
} from '../../../constants/system/actions';

const getDealTaskListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_DEAL_TASK_LIST_DATA, payload, resolve, reject,
});

const deleteDealTaskList: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_DEAL_TASK_LIST, payload, resolve, reject,
});

const deleteDealTaskGroup: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_DEAL_TASK_GROUP, payload, resolve, reject,
});

const saveDealTask: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_DEAL_TASK, payload, resolve, reject,
});

const saveDealTaskStatus: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_DEAL_TASK_STATUS, payload, resolve, reject,
});

const saveDealTaskReviewStatus: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_DEAL_TASK_REVIEW_STATUS, payload, resolve, reject,
});

const saveDealTaskTemplateData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_DEAL_TASK_TEMPLATE_DATA, payload, resolve, reject,
});

const loadDealTaskTemplateData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: LOAD_DEAL_TASK_TEMPLATE_DATA, payload, resolve, reject,
});

const deleteDealTaskComment: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_DEAL_TASK_COMMENT, payload, resolve, reject,
});

const saveDealTaskComment: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_DEAL_TASK_COMMENT, payload, resolve, reject,
});

const saveDealTaskList: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_DEAL_TASK_LIST, payload, resolve, reject,
});

const saveDealTaskGroupOrderSettings: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS, payload, resolve, reject,
});

export {
  getDealTaskListData,
  deleteDealTaskList,
  deleteDealTaskGroup,
  saveDealTask,
  saveDealTaskStatus,
  saveDealTaskReviewStatus,
  saveDealTaskTemplateData,
  loadDealTaskTemplateData,
  deleteDealTaskComment,
  saveDealTaskComment,
  saveDealTaskList,
  saveDealTaskGroupOrderSettings,
};
